import React from "react";

export const Logo = () => <img alt="Logo" src="/img/Logo_oben.png" height={'42px'} />